module.exports = __webpack_public_path__ + "img/geisler.e07a5d71.png";